import { getFormattedDate, getPersonName, getTargetBCPText, getNotAvailableText } from '../../web/section_sf/Utils.js'
import { EnvironmentMap, returnCurrentVendorSite } from '../utils/CommonUtil.js'
import { getLogger } from '@olympeio/core';
import { Config } from "olympe";
import BCP from '../section_bcp/DM_BCP.js';

export const getFullURL = () => {
  return EnvironmentMap[Config.getParameter("ENV")] || "";
}

//Template for PS Email generation
export const generatePsEmailContents = async (username, bcpRequestArray, $) => {
  /** 
  * @param {string} username
  * @param {!Array<[bcpRequestArray]>}
  */
  const logger = getLogger('PSEmailTemplate')
  let emailContent = `
  <p>Dear ${username},</p>
  <p>You have new BCP request(s) that has been assigned to you. Please support in maintaining fields such as main vendor linked, alternative vendor site, cost savings, input saving estimate, GHG reduction, Target BCP, Priority, Macguire Eligible, Oscar ID & remarks accordingly.</p>
  <p>Please click on this <a href="${getFullURL()}">link</a> to go to the Ensuring Supply WebApp and go to the “Manage BCP Request” tab to maintain the input.</p>
  <b>Following BCP request(s) are waiting for your input:</b><br/>
  <table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse;">
    <thead>
      <tr>
        <th style="text-align: left; vertical-align: top; width:90px">Plant</th>
        <th style="text-align: left; vertical-align: top; width:200px">Material</th>
        <th style="text-align: left; vertical-align: top; width:120px">Specification</th>
        <th style="text-align: left; vertical-align: top; width:90px">Main Vendor</th>
        <th style="text-align: left; vertical-align: top; width:90px">Current Vendor site</th>
        <th style="text-align: left; vertical-align: top; width:60px">Requestor</th>
        <th style="text-align: left; vertical-align: top; width:80px">Request date</th>
        <th style="text-align: left; vertical-align: top; width:80px">Main Vendor linked to Alt. Site</th>
        <th style="text-align: left; vertical-align: top; width:80px">Alternative site to be<br/>developed</th>
        <th style="text-align: left; vertical-align: top; width:90px">Target BCP</th>
        <th style="text-align: left; vertical-align: top; width:90px">Priority</th>
        <th style="text-align: left; vertical-align: top; width:60px">Cost Savings</th>
        <th style="text-align: left; vertical-align: top; width:80px">Estimated Savings in CHF</th>
        <th style="text-align: left; vertical-align: top; width:60px">GHG Reduction</th>
        <th style="text-align: left; vertical-align: top; width:240px">Remark</th>
        <th style="text-align: left; vertical-align: top; width:90px">Procurement<br/> Specialist</th>
        <th style="text-align: left; vertical-align: top; width:90px">Business<br/> Partner</th>
        <th style="text-align: left; vertical-align: top; width:90px">Procurement<br/> Manager</th>
        <th style="text-align: left; vertical-align: top; width:90px">CTAG</th>
        <th style="text-align: left; vertical-align: top; width:90px">SQA</th>
        <th style="text-align: left; vertical-align: top; width:90px">QA in the<br/>Factory</th>
      </tr>
    </thead>
    <tbody>`;


  for (let i = 0; i < bcpRequestArray.length; i++) {
    //iterate the all data of bcp object for the particular bcp request or material/plant id
    let data = bcpRequestArray[i].actualBCPObject[0]
    let currentVendorSite;
    if (!data.get(BCP.currentVendorSiteIdProp)) {
      currentVendorSite = await returnCurrentVendorSite(data, $)
    } else {
      currentVendorSite = data.get(BCP.currentVendorSiteIdProp) + ":" + data.get(BCP.currentVendorSiteDescriptionProp)
    }
    //logger.info(":: currentVendorSite ::", currentVendorSite)
    emailContent += `
              <tr>
                <td style="text-align: left; vertical-align:top; width:90px" >${data.get(BCP.plantIdProp) || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top; width:200px" >${(data.get(BCP.materialIdProp) + " - " + (data.get(BCP.materialDescriptionProp) || getNotAvailableText())) || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top; width:120px" >${data.get(BCP.specificationProp) || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top; width:180px" >${data.get(BCP.mainVendorIdProp) ? data.get(BCP.mainVendorIdProp) + ":" + (data.get(BCP.mainVendorDescriptionProp) || getNotAvailableText()) : getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:180px" > ${currentVendorSite}</td>
                <td style="text-align: left; vertical-align:top;width:60px" >${getPersonName(data.get(BCP.requestorProp))?.fullName || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:80px" >${getFormattedDate(data.get(BCP.requestDateProp))}</td>
                <td style="text-align: left; vertical-align:top;width:80px" >${data.get(BCP.mainVendorLinkedAltVendorProp) || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:80px" >${data.get(BCP.alternativeVendorCodeProp) || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:90px" >${getTargetBCPText(data.get(BCP.targetBCPProp)) || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:90px" >${data.get(BCP.priorityProp) || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:60px" >${data.get(BCP.costSavingsProp) || "No"}</td>
                <td style="text-align: left; vertical-align:top;width:90px" >${data.get(BCP.inputSavingEstimatesProp) || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:60px" >${data.get(BCP.ghgReductionProp) || "No"}</td>
                <td style="text-align: left; vertical-align:top;width:240px" >${data.get(BCP.remarkProp) || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(data.get(BCP.procurementSpecialistProp))?.fullName || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(data.get(BCP.businessPartnerProp))?.fullName || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(data.get(BCP.procurementManagerProp))?.fullName || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(data.get(BCP.technicalApplicationGroupProp))?.fullName || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(data.get(BCP.qualityAssuranceProp))?.fullName || getNotAvailableText()}</td>
                <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(data.get(BCP.qaInFactoryProp))?.fullName || getNotAvailableText()}</td>
              </tr>`;
  }

  emailContent += `
    </tbody>
  </table>

  <p>Please do not reply to this email as this is an automatically generated notification.</p>
  <p>Thank you for your collaboration.</p>
  <p>Your Ensuring Supply Team</p>`;

  //logger.info(":: PS email content ::", emailContent)

  return emailContent;
};


